import { render, staticRenderFns } from "./template-view.vue?vue&type=template&id=28bb3f7a"
import script from "./template-view.vue?vue&type=script&lang=js"
export * from "./template-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports